class PipCartDrawer extends HTMLElement {
	constructor() {
		super()
		this.closeButton = this.querySelector(".close-cart-drawer")
		this.cartItemTemplate = this.querySelector("cart-item-template").firstElementChild.cloneNode(true)
		this.cartBoxItemTemplate = this.querySelector("cart-box-item-template").firstElementChild.cloneNode(true)
		this.cartBoxItemFooterTemplate = this.querySelector("cart-box-item-footer-template").firstElementChild.cloneNode(true)
		this.cartDrawerItemsWrapper = this.querySelector(".pip-cart-drawer-items")
		this.cart = null
	}

	async connectedCallback() {
		if (this.querySelector(".close-drawer-bg")) this.querySelector(".close-drawer-bg").addEventListener("click", $event => this.close())
		if (this.closeButton) this.closeButton.addEventListener("click", () => this.close())

		const cart = await fetch("/cart.js").then(response => response.json())
		this.cart = cart
		this.render()
	}

	async update(data) {
		const update = await fetch("/cart/change.js", {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify(data),
		}).then(response => response.json())
		this.cart = update
		this.render(true)
		document.dispatchEvent(new Event("pip-cart-update", {bubbles: true}))
	}

	async removeBox(box) {
		if (!window.confirm("Are you sure you want to remove this box?")) return
		console.log(box)
		console.log(this.cart.items)

		//Clear cart and go through all items and update the quantity of each item in the box and turn it to 0.
		//Then add everything to the bag again.
		let newBag = []
		this.cart.items.forEach(item => {
			newBag.push({
				id: item.id,
				quantity: parseInt(item?.properties?.box_id) === parseInt(box) ? 0 : item.quantity,
				properties: item.properties,
			})
		})
		await fetch(`${window.Shopify.routes.root}cart/clear.js`)
		await fetch(`${window.Shopify.routes.root}cart/add.js`, {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify({
				items: newBag.reverse(),
			}),
		}).then(response => response.json())
		const cart = await fetch("/cart.js").then(response => response.json())
		this.cart = cart
		this.render(true)
	}

	async render(reload = false) {
		if (reload) this.cartDrawerItemsWrapper.innerHTML = ""

		if (this.cart.items_subtotal_price >= 3000) {
			this.querySelector(".free-shipping-ineligible").classList.add("hidden")
			this.querySelector(".free-shipping-eligible").classList.remove("hidden")
			this.querySelector(".cart-freeshipping-progress").classList.add("w-[100%]")
		} else {
			this.querySelector(".free-shipping-ineligible").classList.remove("hidden")
			this.querySelector(".free-shipping-eligible").classList.add("hidden")
			this.querySelector(".cart-freeshipping-progress").classList.remove("w-[100%]")
		}

		this.querySelector(".cart-subtitle").innerText = Shopify.formatMoney(this.cart.total_price)
		this.querySelector(".cart-discounts").innerText = Shopify.formatMoney(this.cart.total_discount)

		this.cart.items.forEach((item, index) => {
			if (item?.properties?.box_type === "pipcorn") return
			const template = this.cartItemTemplate
			template.querySelector(".remove-item-line").setAttribute("data-line", index + 1)
			template.querySelector("input[name='line']").value = index + 1
			template.querySelector(".item_title_link").innerText = item.title
			template.querySelector(".item_title_link").setAttribute("href", item.url)
			template.querySelector(".qty-input").value = item.quantity
			template.querySelector(".item_line_link").setAttribute("href", item.url)
			template.querySelector(".item_line_image").setAttribute("src", item.image)
			template.querySelector(".item_line_variant_title").innerText = item.variant_title
			template.querySelector(".item_line_price").innerText = Shopify.formatMoney(item.final_line_price)
			template.querySelector(".item_line_price_remove").innerText = Shopify.formatMoney(item.final_line_price)
			const appendChild = template.cloneNode(true)
			this.cartDrawerItemsWrapper.appendChild(appendChild)

			appendChild.querySelector("pip-quantity").addEventListener("change", async $event => $event.detail.closest("form").dispatchEvent(new Event("change")))
			appendChild.querySelector(".remove-item-line").addEventListener("click", $event => {
				this.update({
					line: $event.currentTarget.getAttribute("data-line"),
					quantity: 0,
				})
			})
			appendChild.querySelector("form").addEventListener("change", $event => {
				const data = {}
				const formData = new FormData($event.currentTarget)
				formData.forEach((value, key) => (data[key] = value))
				this.update(data)
			})
		})

		//Figure out if we have boxes in the cart.
		const products_in_box = this.cart.items.filter(item => item.properties?.box_type === "pipcorn")
		const boxes_ids = []

		if (products_in_box.length) {
			products_in_box.forEach(item => {
				if (!boxes_ids.includes(item.properties.box_id)) boxes_ids.unshift(item.properties.box_id)
			})

			boxes_ids.forEach(box => {
				let subItemsInGroup = ``
				let subtotal = 0
				let itemIndex = 0

				const boxWrapper = document.createElement("div")
				boxWrapper.classList.add("box-group-wrap", `box-group-${box}`, "p-5", "bg-white", "rounded", "border", "border-[#c9c1b8]", "divide-y")
				this.cartDrawerItemsWrapper.appendChild(boxWrapper)

				products_in_box
					.filter(item => item.properties.box_id === box)
					.forEach((item, index) => {
						this.cart.items.forEach((_item, index) => {
							if (_item.properties?.box_id === box && _item.id === item.id) itemIndex = index
						})

						subtotal += item.final_line_price
						const template = this.cartBoxItemTemplate
						template.classList.add(`box_group_${box}`)

						template.querySelector(".item_title_link").innerText = item.title
						template.querySelector(".item_line_image").setAttribute("src", item.image)
						template.querySelector(".item_line_variant_title").innerText = item.quantity > 1 ? `${item.quantity} Bags` : `${item.quantity} Bag`
						template.querySelector(".item_line_price").innerText = Shopify.formatMoney(item.final_price)
						template.querySelector(".item_line_price_remove").innerText = Shopify.formatMoney(item.final_line_price)
						const appendChild = template.cloneNode(true)
						boxWrapper.appendChild(appendChild)
					})

				const boxFooter = this.cartBoxItemFooterTemplate.cloneNode(true)
				boxWrapper.appendChild(boxFooter)
				boxFooter.querySelector(".box__subtotal").innerText = Shopify.formatMoney(subtotal)
				boxFooter.querySelector(".edit__box").setAttribute("href", `/pages/builder?box=${box}`)
				boxFooter.querySelector(".remove__box").setAttribute("data-box-id", box)
				boxFooter.querySelector(".remove__box").addEventListener("click", () => this.removeBox(box))
			})
		}
	}

	async open() {
		const cart = await fetch("/cart.js").then(response => response.json())
		this.cart = cart
		this.render(true)

		this.classList.remove("hidden")
		setTimeout(() => this.classList.add("active"), 200)
	}

	close() {
		this.classList.remove("active")
		setTimeout(() => this.classList.add("hidden"), 200)
	}
}

customElements.define("pip-cart-drawer", PipCartDrawer)
